
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tools/travel-blog-name-ideas-generator",
      function () {
        return require("private-next-pages/tools/travel-blog-name-ideas-generator.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tools/travel-blog-name-ideas-generator"])
      });
    }
  